import { A } from "@solidjs/router";
import { For } from "solid-js";
import { AplombButton, AplombChip } from "~/components";
import "./index.css";

const VALEURS = [
  {
    icon: "◇",
    titre: "Argent bloqué en escrow",
    description:
      "Votre paiement est retenu en fiducie jusqu'à ce que l'inspection tierce confirme le travail. Aucun débit avant vérification.",
  },
  {
    icon: "✓",
    titre: "Plombiers vérifiés 10 points",
    description:
      "Screening humain de chaque candidat : RBQ, CMMTQ, CCQ, GCR, historique, références client, entrevue vidéo, essai pratique.",
  },
  {
    icon: "!",
    titre: "Vice caché couvert 12 mois",
    description:
      "Si un vice se manifeste dans l'année, la caution du pro couvre la reprise. Vous n'êtes jamais laissé avec la facture.",
  },
];

const ETAPES = [
  { num: 1, titre: "Décrivez", body: "Formulaire 90 secondes : votre problème, adresse, disponibilités." },
  { num: 2, titre: "Comparez", body: "Recevez 2 à 4 propositions de plombiers vérifiés dans 30 minutes." },
  { num: 3, titre: "Payez en escrow", body: "L'argent est retenu — le pro sait qu'il sera payé, vous savez qu'il livrera." },
  { num: 4, titre: "Inspecteur tiers", body: "Un inspecteur indépendant valide le travail selon la norme applicable." },
  { num: 5, titre: "Libération", body: "Une fois validé, l'argent est libéré. Sinon, ajustements ou remboursement." },
];

export default function Landing() {
  return (
    <>
      <header class="a-nav">
        <div class="a-container a-nav__inner">
          <A href="/" class="a-nav__brand" aria-label="Aplomb — accueil">
            <span class="a-nav__brandmark">A|</span>
            <span class="a-nav__brandtext">Aplomb</span>
          </A>
          <nav class="a-nav__links" aria-label="Navigation principale">
            <A href="/comment-ca-marche">Comment ça marche</A>
            <A href="/pour-plombiers">Pour les plombiers</A>
            <A href="/urgence" class="a-nav__cta">
              Signaler une urgence
            </A>
          </nav>
        </div>
      </header>

      <main>
        <section class="a-hero">
          <div class="a-container a-hero__inner">
            <AplombChip variant="attention" compact>
              Version pilote — Grand Montréal
            </AplombChip>
            <h1>Votre argent ne sort qu'une fois le travail vérifié.</h1>
            <p class="a-hero__lede">
              Plateforme de garantie qualité pour plomberie résidentielle. L'argent est retenu en
              escrow jusqu'à ce qu'un inspecteur indépendant confirme le travail. Vice caché couvert
              12 mois.
            </p>
            <div class="a-hero__ctas">
              <A href="/urgence">
                <AplombButton variant="primary" size="large">
                  J'ai une urgence maintenant
                </AplombButton>
              </A>
              <A href="/planifie">
                <AplombButton variant="secondary" size="large">
                  Planifier un travail
                </AplombButton>
              </A>
            </div>
            <p class="a-hero__reassurance">
              Zéro pay-per-lead. Zéro classement payé. Aucun plombier ne monte au-dessus d'un autre
              en payant.
            </p>
          </div>
        </section>

        <section class="a-valeurs">
          <div class="a-container">
            <h2>Pourquoi Aplomb</h2>
            <ul class="a-valeurs__grid">
              <For each={VALEURS}>
                {(item) => (
                  <li class="a-valeurs__card">
                    <span class="a-valeurs__icon" aria-hidden="true">
                      {item.icon}
                    </span>
                    <h3>{item.titre}</h3>
                    <p>{item.description}</p>
                  </li>
                )}
              </For>
            </ul>
          </div>
        </section>

        <section class="a-etapes">
          <div class="a-container">
            <h2>Comment ça marche</h2>
            <ol class="a-etapes__list">
              <For each={ETAPES}>
                {(etape) => (
                  <li class="a-etapes__item">
                    <span class="a-etapes__num" aria-hidden="true">
                      {etape.num}
                    </span>
                    <div>
                      <h3>{etape.titre}</h3>
                      <p>{etape.body}</p>
                    </div>
                  </li>
                )}
              </For>
            </ol>
          </div>
        </section>

        <section class="a-cta-final">
          <div class="a-container">
            <h2>Un problème de plomberie maintenant ?</h2>
            <p>Nous vous mettons en relation avec 2 à 4 plombiers vérifiés en 30 minutes.</p>
            <A href="/urgence">
              <AplombButton variant="primary" size="large">
                Décrire mon urgence
              </AplombButton>
            </A>
          </div>
        </section>
      </main>

      <footer class="a-footer">
        <div class="a-container a-footer__inner">
          <p>
            Aplomb Technologies inc. (constitution en cours) —{" "}
            <A href="/confidentialite">Politique de confidentialité</A> —{" "}
            <A href="/cgu">Conditions d'utilisation</A> —{" "}
            <A href="/rprp">Responsable protection renseignements personnels</A>
          </p>
          <p class="a-footer__loi25">
            Conforme Loi 25 (Québec). Vos données sont hébergées au Canada.
          </p>
        </div>
      </footer>
    </>
  );
}
